// STEP MOA-LIVE-WAKEWORD-FLEX-1 · "라모야" 호출어 공통 설정 (운영 · /vosk-lab 공용).
// 새 별칭은 WAKE_ALIASES 배열에 한 줄 추가.
export const WAKE_ALIASES = ['라모야', '라모', '나모야', '나무야', '라무야'];

// 별칭 뒤에 붙어도 되는 호격/존칭 (예: "라모님").  일반 단어 오매칭 방지를 위해 최소한만.
export const WAKE_SUFFIXES = ['', '님', '씨'];

// 호출어는 발화 구간의 앞부분(0~2번째 단어) 또는 마지막 단어일 때만 인정.
export const WAKE_MAX_POSITION = 2;

// 호출어 감지 후 명령을 기다리는 시간.
export const WAKE_AWAIT_MS = 6000;

// 참고용 — 단어 단위 완전 일치 규칙으로 자동 차단되는 일반 단어 예시.
export const WAKE_BLOCK_EXAMPLES = ['나무', '라면', '나뭇잎', '나무 야무지게', '라모스', '카라모'];

const _tokenize = (text) => String(text || '')
  .toLowerCase()
  .split(/[^0-9a-z\uac00-\ud7a3]+/)
  .filter(Boolean);

const _aliasOf = (token) => {
  for (const a of WAKE_ALIASES) {
    for (const s of WAKE_SUFFIXES) {
      if (token === a + s) return a;
    }
  }
  return null;
};

/** 단일 발화 구간(Vosk partial/result 1 개)에 대해 호출어 판정. */
export const matchWakeWord = (text) => {
  const tokens = _tokenize(text);
  const none = { matched: false, alias: null, index: -1, command: '', tokens };
  for (let i = 0; i < tokens.length; i += 1) {
    const isLast = i === tokens.length - 1;
    let alias = _aliasOf(tokens[i]);
    let span = 1;
    // Vosk 가 음절을 띄어 쓰는 경우 ("라 모야", "라 모 야") — 1 음절 토큰만 결합.
    if (!alias && tokens[i].length === 1) {
      let joined = tokens[i];
      for (let j = i + 1; j < Math.min(tokens.length, i + 3); j += 1) {
        joined += tokens[j];
        const a = _aliasOf(joined);
        if (a) { alias = a; span = j - i + 1; break; }
        if (tokens[j].length !== 1) break;
      }
    }
    if (!alias) continue;
    const endsLast = i + span === tokens.length;
    if (i > WAKE_MAX_POSITION && !(isLast || endsLast)) continue;
    return {
      matched: true, alias, index: i,
      command: tokens.slice(i + span).join(' '),
      tokens,
    };
  }
  return none;
};

/** 여러 구간(Vosk result/partial 배열) 중 첫 매칭 결과. */
export const matchWakeWordInSegments = (segments = []) => {
  for (const s of segments) {
    const m = matchWakeWord(s);
    if (m.matched) return { ...m, segment: s };
  }
  return { matched: false, alias: null, index: -1, command: '', tokens: [], segment: '' };
};

// /vosk-lab 텍스트 표 테스트 케이스 (기대값).
export const WAKE_TEXT_CASES = [
  { text: '라모야', expect: true },
  { text: '라모', expect: true },
  { text: '나모야', expect: true },
  { text: '나무야', expect: true },
  { text: '라무야', expect: true },
  { text: '라모야 1번 상품 보여줘', expect: true },
  { text: '라모야, 다음 상품', expect: true },
  { text: '나모야 가격 보여줘', expect: true },
  { text: '자 라모야 공지 띄워줘', expect: true },
  { text: '라 모야 다음 상품', expect: true },
  { text: '라모님 타이머 시작', expect: true },
  { text: '나무', expect: false },
  { text: '라면', expect: false },
  { text: '나뭇잎', expect: false },
  { text: '나무 야무지게 만들었어요', expect: false },
  { text: '라면 라마단 이야기', expect: false },
  { text: '오늘 나뭇잎 패턴 원피스 보여드릴게요', expect: false },
  { text: '카라모 티셔츠 입고 왔어요', expect: false },
  { text: '라모스 선수 유니폼', expect: false },
  { text: '여러분 오늘 준비한 상품은 나무야 소재로 만든 도마예요', expect: false },
  { text: '안녕하세요 라이브 방송 시작합니다', expect: false },
  { text: '가격은 삼만 구천원입니다', expect: false },
];
